module.exports = __webpack_public_path__ + "img/no paket.e4259747.png";